module.exports = __webpack_public_path__ + "img/solar-side.638cb175.jpg";